export const EXTENSION_PADDING = 8;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const BODIED_EXT_PADDING: number = EXTENSION_PADDING * 2;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const BODIED_EXT_MBE_MARGIN_TOP = 12;
